import { z } from "@/zod";
import { dateTime } from "./commonFields/dateTime";
import { timeWithOptionalSeconds } from "./commonFields/time";
import { NUMBER_SCHEMA } from "./commonFields/numberSchema";

export const timesheetEntry = z.object({
  id: z.string().min(26),
  shift_id: z.string().min(26),
  shift_name: z.string(),
  shift_report_id: z.string().min(26),
  shift_report_date: z.string().date(),
  store_id: z.string().min(26),
  store_name: z.string(),
  contractors_count: z.number().nonnegative(),
  total_hours_without_break: z.number().nonnegative(),
  full_time_equivalent: z.number().nonnegative().describe(NUMBER_SCHEMA),
  regional_director_name: z.string().nullable(),
  regional_representative_name: z.string().nullable(),
  supervisor_name: z.string().nullable(),
  store_coordinator_name: z.string().nullable(),
});

export const readTimesheetEntry = timesheetEntry.readonly();

export const writeTimesheetEntry = z.object({
  start_datetime: z.preprocess(
    (val) => (val === "" ? undefined : val),
    dateTime.optional(),
  ),
  end_datetime: z.preprocess(
    (val) => (val === "" ? undefined : val),
    dateTime.optional(),
  ),
  contractor_id: z.string().min(26),
  break_time: z.preprocess(
    (val) => (val === "" ? undefined : val),
    timeWithOptionalSeconds.optional(),
  ),
  payroll_department_id: z.string().min(26),
  id: z.string().optional(),
  shift_report_id: z.string(),
});
